"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _overload4 = _interopRequireDefault(require("./util/overload"));

var _get = _interopRequireWildcard(require("./get"));

var _set = _interopRequireWildcard(require("./set"));

var _overload, _overload2, _overload3;

var updateSelf = function updateSelf(updater) {
  return function (value) {
    return updater(value);
  };
};

var updateAll = function updateAll(key, updater) {
  var notSetValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return function (value) {
    return (0, _set.default)(key, updater((0, _get.default)(key, notSetValue)(value)))(value);
  };
};

var updateObject = function updateObject(key, updater) {
  var notSetValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return function (value) {
    return (0, _set.objectSet)(key, updater((0, _get.objectGet)(key, notSetValue)(value)))(value);
  };
};

var updateArray = function updateArray(key, updater) {
  var notSetValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return function (value) {
    return (0, _set.arraySet)(key, updater((0, _get.arrayGet)(key, notSetValue)(value)))(value);
  };
};

var _default = (0, _unmutable.default)({
  name: 'update',
  immutable: 'update',
  object: (0, _overload4.default)((_overload = {}, (0, _defineProperty2.default)(_overload, "1", updateSelf), (0, _defineProperty2.default)(_overload, "2", function _(key, updater) {
    return updateObject(key, updater);
  }), (0, _defineProperty2.default)(_overload, "3", function _(key, notSetValue, updater) {
    return updateObject(key, updater, notSetValue);
  }), _overload)),
  array: (0, _overload4.default)((_overload2 = {}, (0, _defineProperty2.default)(_overload2, "1", updateSelf), (0, _defineProperty2.default)(_overload2, "2", function _(key, updater) {
    return updateArray(key, updater);
  }), (0, _defineProperty2.default)(_overload2, "3", function _(key, notSetValue, updater) {
    return updateArray(key, updater, notSetValue);
  }), _overload2)),
  all: (0, _overload4.default)((_overload3 = {}, (0, _defineProperty2.default)(_overload3, "1", updateSelf), (0, _defineProperty2.default)(_overload3, "2", function _(key, updater) {
    return updateAll(key, updater);
  }), (0, _defineProperty2.default)(_overload3, "3", function _(key, notSetValue, updater) {
    return updateAll(key, updater, notSetValue);
  }), _overload3))
});

exports.default = _default;